import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "media";

export type mediaTypeData = {
    media_name: string;
    id_media_ref: number | null
}
export type listMedia = {
    keyword?: string;
}
export class MediaApi extends BaseAPI {

    static createMedia(body: mediaTypeData): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static updateMedia(id_media: number, body: mediaTypeData): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_media}`, body)
    }
    static treeList(query: listMedia): Promise<AxiosResponse> {
        return this.api.get(`${path}/tree`, { params: { ...query } })
    }
    static createFile(id_media: number, file: FormData): Promise<AxiosResponse> {
        return this.api.post(`${path}/${id_media}/upload-media-file`, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    static getMediaFile(id_media: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_media}/get-media-files`)
    }
    static findOneFile(id_media_file: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_media_file}/get-one-media-file`)
    }
    static deleteFolder(id_media: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_media}/delete-media`)
    }
    static deleteFile(id_media_file: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_media_file}/delete-media-file`)
    }
    static uploadFilePublic(body: FormData): Promise<AxiosResponse> {
        return this.api.post(`${path}/upload-file-media-public`, body);
    }
}